export default __webpack_public_path__ + "static/media/img.fdc85094.jpg";